import { Spin } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import {
  UploaderState,
  useUploadFormStore,
} from 'stores/local/forms/UploadFormStore';

const UploadingFileState: React.FC = () => {
  const { t } = useTranslation();
  const store = useUploadFormStore();
  const [showProgress, setShowProgress] = React.useState(false);

  React.useEffect(() => {
    if (!store.uploadStartTime) {
      setShowProgress(false);
      return;
    }

    const timer = setTimeout(() => {
      // Проверяем, что загрузка все еще идет
      if (store.uploaderState === UploaderState.loading) {
        setShowProgress(true);
      }
    }, 500);

    return () => {
      clearTimeout(timer);
    };
  }, [store.uploadStartTime, store.uploaderState]);

  return (
    <>
      <p className="ant-upload-drag-icon">
        {showProgress ? <Spin /> : <UploadOutlined />}
      </p>
      <p className="ant-upload-text">{t('formFilling.uploading')}</p>
    </>
  );
};

export default observer(UploadingFileState);
